/**
 * Quick View Modal — Gumyum Theme
 * Fetches product JSON via /products/<handle>.js and renders a modal.
 * Triggered by [data-quickview-open] buttons on product cards.
 */
(function() {
  'use strict';

  var overlay = document.getElementById('quick-view-overlay');
  var modal = document.getElementById('quick-view-modal');
  var content = document.getElementById('quick-view-content');
  if (!overlay || !modal || !content) return;

  var productCache = {};
  var lastTrigger = null;

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escape(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openModal(trigger) {
    lastTrigger = trigger;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Focus close button for keyboard users
    var closeBtn = modal.querySelector('[data-quickview-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function renderProduct(product) {
    var firstAvailable = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    var image = (product.images && product.images[0]) || product.featured_image || '';
    var hasMultipleVariants = product.variants.length > 1 && !(product.variants.length === 1 && product.variants[0].title === 'Default Title');

    var html = '';
    html += '<div class="quick-view__media">';
    if (image) {
      html += '<img src="' + escape(image) + '" alt="' + escape(product.title) + '" loading="eager">';
    }
    html += '</div>';

    html += '<div class="quick-view__content">';
    if (product.type) {
      html += '<p class="quick-view__type">' + escape(product.type) + '</p>';
    }
    html += '<h2 class="quick-view__title" id="quick-view-title">' + escape(product.title) + '</h2>';

    var priceLine = '<p class="quick-view__price"><span data-qv-price>' + formatMoney(firstAvailable.price) + '</span>';
    if (firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price) {
      priceLine += '<span class="quick-view__price-compare" data-qv-compare>' + formatMoney(firstAvailable.compare_at_price) + '</span>';
    }
    priceLine += '</p>';
    html += priceLine;

    if (product.description) {
      // Strip HTML, keep first ~200 chars
      var temp = document.createElement('div');
      temp.innerHTML = product.description;
      var text = (temp.textContent || temp.innerText || '').trim();
      if (text.length > 240) text = text.slice(0, 240).trim() + '…';
      html += '<p class="quick-view__desc">' + escape(text) + '</p>';
    }

    if (hasMultipleVariants) {
      html += '<div class="quick-view__variants" role="radiogroup" aria-label="Choose variant">';
      product.variants.forEach(function(v) {
        var attrs = 'data-qv-variant="' + v.id + '" data-qv-price-cents="' + v.price + '"';
        if (v.compare_at_price) attrs += ' data-qv-compare-cents="' + v.compare_at_price + '"';
        if (!v.available) attrs += ' disabled';
        var activeClass = v.id === firstAvailable.id ? ' is-active' : '';
        html += '<button type="button" class="quick-view__variant-btn' + activeClass + '" ' + attrs + ' role="radio" aria-checked="' + (v.id === firstAvailable.id) + '">' + escape(v.title) + '</button>';
      });
      html += '</div>';
    }

    html += '<div class="quick-view__actions">';
    if (firstAvailable.available) {
      html += '<button type="button" class="quick-view__atc" data-qv-atc data-variant-id="' + firstAvailable.id + '">Add to Cart</button>';
    } else {
      html += '<button type="button" class="quick-view__atc" disabled>Sold Out</button>';
    }
    html += '<a class="quick-view__view-full" href="' + escape(product.url) + '">View full details</a>';
    html += '</div>';

    html += '</div>';

    content.innerHTML = html;
    bindVariantSwitching(product);
    bindAddToCart();
  }

  function bindVariantSwitching(product) {
    var btns = content.querySelectorAll('[data-qv-variant]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-qv-variant');
        var priceCents = parseInt(btn.getAttribute('data-qv-price-cents'), 10);
        var compareCents = parseInt(btn.getAttribute('data-qv-compare-cents'), 10);

        btns.forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');

        var priceEl = content.querySelector('[data-qv-price]');
        if (priceEl) priceEl.textContent = formatMoney(priceCents);

        var compareEl = content.querySelector('[data-qv-compare]');
        if (compareCents && compareCents > priceCents) {
          if (compareEl) {
            compareEl.textContent = formatMoney(compareCents);
          } else if (priceEl) {
            var span = document.createElement('span');
            span.className = 'quick-view__price-compare';
            span.setAttribute('data-qv-compare', '');
            span.textContent = formatMoney(compareCents);
            priceEl.parentNode.insertBefore(span, priceEl.nextSibling);
          }
        } else if (compareEl) {
          compareEl.remove();
        }

        var atc = content.querySelector('[data-qv-atc]');
        if (atc) atc.setAttribute('data-variant-id', variantId);
      });
    });
  }

  function bindAddToCart() {
    var atc = content.querySelector('[data-qv-atc]');
    if (!atc) return;
    atc.addEventListener('click', async function() {
      var variantId = atc.getAttribute('data-variant-id');
      if (!variantId || atc.disabled) return;

      var originalText = atc.textContent;
      atc.textContent = 'Adding…';
      atc.disabled = true;

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Add to cart failed');

        // Refresh cart count badge via the existing function (theme.js)
        try {
          var cartRes = await fetch('/cart.js');
          var cart = await cartRes.json();
          if (window.updateCartCount) {
            window.updateCartCount(cart.item_count);
          } else {
            // Fallback: dispatch a custom event so other listeners can react
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          }
        } catch (e) { /* ignore */ }

        atc.textContent = 'Added ✓';
        setTimeout(function() {
          atc.textContent = originalText;
          atc.disabled = false;
          closeModal();
          // Open the cart drawer if available
          var drawer = document.querySelector('.cart-drawer');
          var overlay = document.querySelector('.cart-overlay');
          if (drawer && overlay) {
            drawer.classList.add('active');
            overlay.classList.add('active');
            if (window.loadCartContents) window.loadCartContents();
          }
        }, 700);
      } catch (e) {
        atc.textContent = 'Try again';
        atc.disabled = false;
        console.error('Quick-view ATC failed', e);
      }
    });
  }

  async function loadProduct(handle) {
    if (productCache[handle]) {
      renderProduct(productCache[handle]);
      return;
    }
    content.innerHTML = '<div class="quick-view-modal__loading" aria-live="polite">Loading…</div>';
    try {
      var res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (!res.ok) throw new Error('Product fetch failed');
      var product = await res.json();
      productCache[handle] = product;
      renderProduct(product);
    } catch (e) {
      content.innerHTML = '<div class="quick-view-modal__loading">Couldn’t load product. <a href="/products/' + encodeURIComponent(handle) + '" style="margin-left:6px;text-decoration:underline;">Go to product page</a></div>';
      console.error('Quick-view load failed', e);
    }
  }

  // Event delegation — covers cards added later (e.g. by quick-view sort/filter)
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-quickview-open]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;
      openModal(trigger);
      loadProduct(handle);
      return;
    }
    if (e.target.closest('[data-quickview-close]')) {
      closeModal();
      return;
    }
    if (e.target === overlay) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
